// extracted by mini-css-extract-plugin
export default {"currentNum":"GridPointInfo_currentNum__VwJmK","gridPoint":"GridPointInfo_gridPoint__Pa4bf","headerBox":"GridPointInfo_headerBox__vtODz","tableBox":"GridPointInfo_tableBox__FhYqI"};